// extracted by mini-css-extract-plugin
export default {"panel":"AccountPanel_panel__a6uMc","card":"AccountPanel_card__y+vy9","avatar":"AccountPanel_avatar__bRdD5","name":"AccountPanel_name__XHUXF","email":"AccountPanel_email__ivvBF"};